export function formatOwnerLastNameForLabel(
  lastName?: string,
): string | undefined {
  const trimmed = lastName?.trim();
  if (!trimmed) {
    return undefined;
  }
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}
